#import "../fragments/tag-basic.graphql"

mutation DeleteTag($input: DeleteTagInput!) {
    deleteTag(input: $input) {
        tag {
            ...TagBasic
        }
    }
}
